import { Controller } from "@hotwired/stimulus";
import debounce from "lodash.debounce";

export default class extends Controller {
  static targets = ["form", "lineTotal", "grandTotal"];

  connect() {
    this.debouncedSubmit = debounce(this.submitCart.bind(this), 500);
  }

  updateQuantity(event) {
    const input = event.target;
    if (!event.isTrusted) return;

    const form = input.closest("form");
    if (!form.reportValidity()) {
      form.classList.add("was-validated");

      event.preventDefault();
      event.stopPropagation();
      return;
    }

    this.updateLineTotal(input);
    this.debouncedSubmit();
  }

  updateLineTotal(input) {
    const row = input.closest("tr");
    const td = row.querySelector("[data-cart-target='lineTotal']");

    td.innerHTML = `<div class="spinner-border spinner-border-sm text-muted"
      role="status" aria-hidden="true"></div>`;
    this.flashRow(row);
  }

  flashRow(row) {
    row.classList.add("flash");
    setTimeout(() => {
      row.classList.remove("flash");
    }, 600);
  }

  submitCart() {
    this.formTarget.requestSubmit();
  }
}
